import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Partners } from "@/components/Partners";
import { Services } from "@/components/Services";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FBF9F5]">
      <Header />
      <main>
        <Hero />
        <About />
        <Partners />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
